import React from 'react';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import classNames from 'classnames';
import { cloneElement, isValidElement } from '../../_util/reactNode';
export function renderSwitcherIcon(prefixCls, switcherIcon, showLine, nodeProps) {
    const { isLeaf } = nodeProps;
    if (isLeaf) {
        if (!showLine) {
            return null;
        }
        return <span className={`${prefixCls}-switcher-leaf-line`}/>;
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === 'function' ? switcherIcon(nodeProps) : switcherIcon;
    if (isValidElement(switcher)) {
        return cloneElement(switcher, {
            className: classNames(switcher.props.className || '', switcherCls)
        });
    }
    if (switcher) {
        return switcher;
    }
    return <OutlinedDown className={switcherCls}/>;
}
;
